export type HcpcsModifierOption = {
  code: string;
  description: string;
};

/** CMS HCPCS Level II / CPT modifier catalog for the CPT® / HCPCS Editor dropdown. */
export const HCPCS_MODIFIER_CATALOG: HcpcsModifierOption[] = [
  { code: "22", description: "Increased procedural services" },
  { code: "23", description: "Unusual anesthesia" },
  { code: "24", description: "Unrelated E/M service by the same physician during a postoperative period" },
  { code: "25", description: "Significant, separately identifiable E/M service on the same day" },
  { code: "26", description: "Professional component" },
  { code: "27", description: "Multiple outpatient hospital E/M encounters on the same date" },
  { code: "32", description: "Mandated services" },
  { code: "33", description: "Preventive services" },
  { code: "47", description: "Anesthesia by surgeon" },
  { code: "50", description: "Bilateral procedure" },
  { code: "51", description: "Multiple procedures" },
  { code: "52", description: "Reduced services" },
  { code: "53", description: "Discontinued procedure" },
  { code: "54", description: "Surgical care only" },
  { code: "55", description: "Postoperative management only" },
  { code: "56", description: "Preoperative management only" },
  { code: "57", description: "Decision for surgery" },
  { code: "58", description: "Staged or related procedure during the postoperative period" },
  { code: "59", description: "Distinct procedural service" },
  { code: "62", description: "Two surgeons" },
  { code: "63", description: "Procedure performed on infants less than 4 kg" },
  { code: "66", description: "Surgical team" },
  { code: "73", description: "Discontinued outpatient hospital/ASC procedure prior to anesthesia" },
  { code: "74", description: "Discontinued outpatient hospital/ASC procedure after anesthesia" },
  { code: "76", description: "Repeat procedure or service by same physician" },
  { code: "77", description: "Repeat procedure by another physician" },
  { code: "78", description: "Unplanned return to the operating room" },
  { code: "79", description: "Unrelated procedure during the postoperative period" },
  { code: "80", description: "Assistant surgeon" },
  { code: "81", description: "Minimum assistant surgeon" },
  { code: "82", description: "Assistant surgeon (when qualified resident surgeon not available)" },
  { code: "90", description: "Reference (outside) laboratory" },
  { code: "91", description: "Repeat clinical diagnostic laboratory test" },
  { code: "92", description: "Alternative laboratory platform testing" },
  { code: "95", description: "Synchronous telemedicine service" },
  { code: "96", description: "Habilitative services" },
  { code: "97", description: "Rehabilitative services" },
  { code: "99", description: "Multiple modifiers" },
  { code: "A1", description: "Dressing for one wound" },
  { code: "A2", description: "Dressing for two wounds" },
  { code: "A3", description: "Dressing for three wounds" },
  { code: "A4", description: "Dressing for four wounds" },
  { code: "A5", description: "Dressing for five wounds" },
  { code: "A6", description: "Dressing for six wounds" },
  { code: "A7", description: "Dressing for seven wounds" },
  { code: "A8", description: "Dressing for eight wounds" },
  { code: "A9", description: "Dressing for nine or more wounds" },
  { code: "AA", description: "Anesthesia services performed personally by anesthesiologist" },
  { code: "AD", description: "Medical supervision by a physician: more than four concurrent anesthesia procedures" },
  { code: "AE", description: "Registered dietician" },
  { code: "AF", description: "Specialty physician" },
  { code: "AG", description: "Primary physician" },
  { code: "AH", description: "Clinical psychologist" },
  { code: "AI", description: "Principal physician of record" },
  { code: "AJ", description: "Clinical social worker" },
  { code: "AK", description: "Non-participating physician" },
  { code: "AM", description: "Physician, team member service" },
  { code: "AN", description: "PA/NP/CNS services for a HOOP" },
  { code: "AO", description: "PA/NP/CNS services in a HPSA" },
  { code: "AP", description: "Determination of refractive state was not performed" },
  { code: "AQ", description: "Physician providing service in an unlisted HPSA" },
  { code: "AR", description: "Physician in scarcity area" },
  { code: "AS", description: "PA/NP/CNS as assistant at surgery" },
  { code: "AT", description: "Acute treatment" },
  { code: "AU", description: "Item furnished in conjunction with a urological, ostomy, or tracheostomy supply" },
  { code: "AV", description: "Item furnished in conjunction with a prosthetic device, prosthetic or orthotic" },
  { code: "AW", description: "Item furnished in conjunction with a surgical dressing" },
  { code: "AX", description: "Item furnished in conjunction with dialysis services" },
  { code: "AY", description: "Item or service furnished to an ESRD patient that is not for the treatment of ESRD" },
  { code: "AZ", description: "Physician providing a service in a dental health professional shortage area" },
  { code: "BA", description: "Item furnished in conjunction with parenteral enteral nutrition (PEN) services" },
  { code: "BL", description: "Special acquisition of blood and blood products" },
  { code: "BO", description: "Orally administered nutrition, not by feeding tube" },
  { code: "BP", description: "The beneficiary has been informed of the purchase and rental options and has elected to purchase the item" },
  { code: "BR", description: "The beneficiary has been informed of the purchase and rental options and has elected to rent the item" },
  { code: "BU", description: "The beneficiary has been informed of the purchase and rental options and has not yet elected" },
  { code: "CA", description: "Procedure payable only in the inpatient setting when performed emergently on an outpatient who expires" },
  { code: "CB", description: "Service ordered by a renal dialysis facility (RDF) physician for ESRD beneficiary" },
  { code: "CC", description: "Procedure code change" },
  { code: "CD", description: "AMCC test for ESRD or MCP physician" },
  { code: "CE", description: "AMCC test for ESRD or MCP physician that is beyond the composite rate" },
  { code: "CF", description: "AMCC test for ESRD or MCP physician that is not part of the composite rate" },
  { code: "CG", description: "Policy criteria applied" },
  { code: "CR", description: "Catastrophe/disaster related" },
  { code: "CS", description: "Cost-sharing waived for specified COVID-19 testing-related services" },
  { code: "CT", description: "Computed tomography services furnished using equipment that does not meet NEMA XR-29-2013" },
  { code: "E1", description: "Upper left, eyelid" },
  { code: "E2", description: "Lower left, eyelid" },
  { code: "E3", description: "Upper right, eyelid" },
  { code: "E4", description: "Lower right, eyelid" },
  { code: "EA", description: "Erythropoietic stimulating agent (ESA) administered to treat anemia due to anti-cancer chemotherapy" },
  { code: "EB", description: "ESA administered to treat anemia due to anti-cancer radiotherapy" },
  { code: "EC", description: "ESA administered to treat anemia not due to anti-cancer radiotherapy or chemotherapy" },
  { code: "ED", description: "Hematocrit greater than 39.0% or hemoglobin greater than 13.0g/dL for 3 or more consecutive billing cycles" },
  { code: "EE", description: "Hematocrit greater than 39.0% or hemoglobin greater than 13.0g/dL for less than 3 consecutive billing cycles" },
  { code: "EJ", description: "Subsequent claims for a defined course of therapy" },
  { code: "EM", description: "Emergency reserve supply (for ESRD benefit only)" },
  { code: "EP", description: "Service provided as part of Medicaid early periodic screening diagnosis and treatment (EPSDT) program" },
  { code: "ET", description: "Emergency services" },
  { code: "EX", description: "Expatriate beneficiary" },
  { code: "EY", description: "No physician or other licensed health care provider order for this item or service" },
  { code: "F1", description: "Left hand, second digit" },
  { code: "F2", description: "Left hand, third digit" },
  { code: "F3", description: "Left hand, fourth digit" },
  { code: "F4", description: "Left hand, fifth digit" },
  { code: "F5", description: "Right hand, thumb" },
  { code: "F6", description: "Right hand, second digit" },
  { code: "F7", description: "Right hand, third digit" },
  { code: "F8", description: "Right hand, fourth digit" },
  { code: "F9", description: "Right hand, fifth digit" },
  { code: "FA", description: "Left hand, thumb" },
  { code: "FB", description: "Item provided without cost to provider, supplier or practitioner" },
  { code: "FC", description: "Partial credit received for replaced device" },
  { code: "FP", description: "Service provided as part of family planning program" },
  { code: "FX", description: "X-ray taken using film" },
  { code: "FY", description: "X-ray taken using computed radiography technology" },
  { code: "G0", description: "Telehealth services for diagnosis, evaluation, or treatment of symptoms of an acute stroke" },
  { code: "G1", description: "Most recent URR of less than 60%" },
  { code: "G2", description: "Most recent URR of 60% to 64.9%" },
  { code: "G3", description: "Most recent URR of 65% to 69.9%" },
  { code: "G4", description: "Most recent URR of 70% to 74.9%" },
  { code: "G5", description: "Most recent URR of 75% or greater" },
  { code: "G6", description: "ESRD patient for whom less than six dialysis sessions have been provided in a month" },
  { code: "G7", description: "Pregnancy resulted from rape or incest or pregnancy certified by physician as life threatening" },
  { code: "G8", description: "Monitored anesthesia care (MAC) for deep complex, complicated, or markedly invasive surgical procedure" },
  { code: "G9", description: "Monitored anesthesia care for a patient who has a history of severe cardiopulmonary condition" },
  { code: "GA", description: "Waiver of liability statement issued as required by payer policy" },
  { code: "GB", description: "Claim being resubmitted for payment because it is no longer covered under a global payment" },
  { code: "GC", description: "This service has been performed in part by a resident under the direction of a teaching physician" },
  { code: "GE", description: "This service has been performed by a resident without the presence of a teaching physician under the primary care exception" },
  { code: "GF", description: "Nonphysician (e.g. nurse practitioner) services in a critical access hospital" },
  { code: "GG", description: "Performance and payment of a screening mammogram and diagnostic mammogram on the same patient, same day" },
  { code: "GH", description: "Diagnostic mammogram converted from screening mammogram on same day" },
  { code: "GJ", description: "Opt out physician or practitioner emergency or urgent service" },
  { code: "GK", description: "Reasonable and necessary item/service associated with a GA or GZ modifier" },
  { code: "GL", description: "Medically unnecessary upgrade provided instead of a non-upgraded item, no charge, no ABN" },
  { code: "GM", description: "Multiple patients on one ambulance trip" },
  { code: "GN", description: "Services delivered under an outpatient speech-language pathology plan of care" },
  { code: "GO", description: "Services delivered under an outpatient occupational therapy plan of care" },
  { code: "GP", description: "Services delivered under an outpatient physical therapy plan of care" },
  { code: "GQ", description: "Via asynchronous telecommunications system" },
  { code: "GT", description: "Via interactive audio and video telecommunication systems" },
  { code: "GU", description: "Waiver of liability statement issued as required by payer policy, routine notice" },
  { code: "GV", description: "Attending physician not employed or paid under arrangement by the patient's hospice provider" },
  { code: "GW", description: "Service not related to the hospice patient's terminal condition" },
  { code: "GX", description: "Notice of liability issued, voluntary under payer policy" },
  { code: "GY", description: "Item or service statutorily excluded, does not meet the definition of any Medicare benefit" },
  { code: "GZ", description: "Item or service expected to be denied as not reasonable and necessary" },
  { code: "H9", description: "Court-ordered" },
  { code: "HA", description: "Child/adolescent program" },
  { code: "HB", description: "Adult program, non geriatric" },
  { code: "HC", description: "Adult program, geriatric" },
  { code: "HD", description: "Pregnant/parenting women's program" },
  { code: "HE", description: "Mental health program" },
  { code: "HF", description: "Substance abuse program" },
  { code: "HG", description: "Opioid addiction treatment program" },
  { code: "HH", description: "Integrated mental health/substance abuse program" },
  { code: "HI", description: "Integrated mental health and intellectual disability/developmental disabilities program" },
  { code: "HJ", description: "Employee assistance program" },
  { code: "HK", description: "Specialized mental health programs for high-risk populations" },
  { code: "HL", description: "Intern" },
  { code: "HM", description: "Less than bachelor degree level" },
  { code: "HN", description: "Bachelors degree level" },
  { code: "HO", description: "Masters degree level" },
  { code: "HP", description: "Doctoral level" },
  { code: "HQ", description: "Group setting" },
  { code: "HR", description: "Family/couple with client present" },
  { code: "HS", description: "Family/couple without client present" },
  { code: "HT", description: "Multi-disciplinary team" },
  { code: "HU", description: "Funded by child welfare agency" },
  { code: "HV", description: "Funded state addictions agency" },
  { code: "HW", description: "Funded by state mental health agency" },
  { code: "HX", description: "Funded by county/local agency" },
  { code: "HY", description: "Funded by juvenile justice agency" },
  { code: "HZ", description: "Funded by criminal justice agency" },
  { code: "J1", description: "Competitive acquisition program no-pay submission for a prescription number" },
  { code: "J2", description: "Competitive acquisition program, restocking of emergency drugs after emergency administration" },
  { code: "J3", description: "Competitive acquisition program, medication not available through CAP" },
  { code: "J4", description: "DMEPOS item subject to DMEPOS competitive bidding program that is furnished by a hospital" },
  { code: "JA", description: "Administered intravenously" },
  { code: "JB", description: "Administered subcutaneously" },
  { code: "JC", description: "Skin substitute used as a graft" },
  { code: "JD", description: "Skin substitute not used as a graft" },
  { code: "JE", description: "Administered via dialysate" },
  { code: "JG", description: "Drug or biological acquired with 340B drug pricing program discount" },
  { code: "JW", description: "Drug amount discarded/not administered to any patient" },
  { code: "JZ", description: "Zero drug amount discarded/not administered to any patient" },
  { code: "K0", description: "Lower extremity prosthesis functional level 0" },
  { code: "K1", description: "Lower extremity prosthesis functional level 1" },
  { code: "K2", description: "Lower extremity prosthesis functional level 2" },
  { code: "K3", description: "Lower extremity prosthesis functional level 3" },
  { code: "K4", description: "Lower extremity prosthesis functional level 4" },
  { code: "KA", description: "Add on option/accessory for wheelchair" },
  { code: "KB", description: "Beneficiary requested upgrade for ABN, more than 4 modifiers" },
  { code: "KC", description: "Replacement of special power wheelchair interface" },
  { code: "KD", description: "Drug or biological infused through DME" },
  { code: "KE", description: "Bid under round one of the DMEPOS competitive bidding program for use with non-competitive bid base equipment" },
  { code: "KF", description: "Item designated by FDA as class III device" },
  { code: "KG", description: "DMEPOS item subject to DMEPOS competitive bidding program number 1" },
  { code: "KH", description: "DMEPOS item, initial claim, purchase or first month rental" },
  { code: "KI", description: "DMEPOS item, second or third month rental" },
  { code: "KJ", description: "DMEPOS item, parenteral enteral nutrition (PEN) pump or capped rental, months four to fifteen" },
  { code: "KK", description: "DMEPOS item subject to DMEPOS competitive bidding program number 2" },
  { code: "KL", description: "DMEPOS item delivered via mail" },
  { code: "KM", description: "Replacement of facial prosthesis including new impression/moulage" },
  { code: "KN", description: "Replacement of facial prosthesis using previous master model" },
  { code: "KO", description: "Single drug unit dose formulation" },
  { code: "KP", description: "First drug of a multiple drug unit dose formulation" },
  { code: "KQ", description: "Second or subsequent drug of a multiple drug unit dose formulation" },
  { code: "KR", description: "Rental item, billing for partial month" },
  { code: "KS", description: "Glucose monitor supply for diabetic beneficiary not treated with insulin" },
  { code: "KT", description: "Beneficiary resides in a competitive bidding area and travels outside that area" },
  { code: "KU", description: "DMEPOS item subject to DMEPOS competitive bidding program number 3" },
  { code: "KV", description: "DMEPOS item subject to DMEPOS competitive bidding program that is furnished as part of a professional service" },
  { code: "KW", description: "DMEPOS item subject to DMEPOS competitive bidding program number 4" },
  { code: "KX", description: "Requirements specified in the medical policy have been met" },
  { code: "KY", description: "DMEPOS item subject to DMEPOS competitive bidding program number 5" },
  { code: "KZ", description: "New coverage not implemented by managed care" },
  { code: "LC", description: "Left circumflex coronary artery" },
  { code: "LD", description: "Left anterior descending coronary artery" },
  { code: "LL", description: "Lease/rental (use the LL modifier when DME equipment rental is to be applied against the purchase price)" },
  { code: "LM", description: "Left main coronary artery" },
  { code: "LR", description: "Laboratory round trip" },
  { code: "LS", description: "FDA-monitored intraocular lens implant" },
  { code: "LT", description: "Left side" },
  { code: "M2", description: "Medicare secondary payer (MSP)" },
  { code: "MS", description: "Six month maintenance and servicing fee for reasonable and necessary parts and labor" },
  { code: "NB", description: "Nebulizer system, any type, FDA-cleared for use with specific drug" },
  { code: "NR", description: "New when rented" },
  { code: "NU", description: "New equipment" },
  { code: "P1", description: "A normal healthy patient" },
  { code: "P2", description: "A patient with mild systemic disease" },
  { code: "P3", description: "A patient with severe systemic disease" },
  { code: "P4", description: "A patient with severe systemic disease that is a constant threat to life" },
  { code: "P5", description: "A moribund patient who is not expected to survive without the operation" },
  { code: "P6", description: "A declared brain-dead patient whose organs are being removed for donor purposes" },
  { code: "PA", description: "Surgical or other invasive procedure on wrong body part" },
  { code: "PB", description: "Surgical or other invasive procedure on wrong patient" },
  { code: "PC", description: "Wrong surgery or other invasive procedure on patient" },
  { code: "PD", description: "Diagnostic or related non diagnostic item or service provided in a wholly owned or operated entity to a patient who is admitted as an inpatient within 3 days" },
  { code: "PI", description: "PET or PET/CT to inform the initial treatment strategy of tumors" },
  { code: "PL", description: "Progressive addition lenses" },
  { code: "PM", description: "Post mortem" },
  { code: "PN", description: "Non-excepted service provided at an off-campus, outpatient, provider-based department of a hospital" },
  { code: "PO", description: "Excepted service provided at an off-campus, outpatient, provider-based department of a hospital" },
  { code: "PS", description: "PET or PET/CT to inform the subsequent treatment strategy of cancerous tumors" },
  { code: "PT", description: "Colorectal cancer screening test; converted to diagnostic test or other procedure" },
  { code: "Q0", description: "Investigational clinical service provided in a clinical research study that is an approved clinical research study" },
  { code: "Q1", description: "Routine clinical service provided in a clinical research study that is an approved clinical research study" },
  { code: "Q2", description: "Demonstration procedure/service" },
  { code: "Q3", description: "Live kidney donor surgery and related services" },
  { code: "Q4", description: "Service for ordering/referring physician qualifies as a service exception" },
  { code: "Q5", description: "Service furnished under a reciprocal billing arrangement by a substitute physician" },
  { code: "Q6", description: "Service furnished under a fee-for-time compensation arrangement by a substitute physician" },
  { code: "Q7", description: "One Class A finding" },
  { code: "Q8", description: "Two Class B findings" },
  { code: "Q9", description: "One Class B and two Class C findings" },
  { code: "QA", description: "Prescribed amounts of stationary oxygen for daytime use while at rest and nighttime use differ" },
  { code: "QB", description: "Prescribed amounts of oxygen described in liters per minute" },
  { code: "QC", description: "Single channel monitoring" },
  { code: "QD", description: "Recording and storage in solid state memory by a digital recorder" },
  { code: "QE", description: "Prescribed amount of oxygen is less than 1 liter per minute (LPM)" },
  { code: "QF", description: "Prescribed amount of oxygen exceeds 4 liters per minute (LPM) and portable oxygen is prescribed" },
  { code: "QG", description: "Prescribed amount of oxygen is greater than 4 liters per minute (LPM)" },
  { code: "QH", description: "Oxygen conserving device is being used with an oxygen delivery system" },
  { code: "QJ", description: "Services/items provided to a prisoner or patient in state or local custody" },
  { code: "QK", description: "Medical direction of two, three, or four concurrent anesthesia procedures involving qualified individuals" },
  { code: "QL", description: "Patient pronounced dead after ambulance called" },
  { code: "QM", description: "Ambulance service provided under arrangement by a provider of services" },
  { code: "QN", description: "Ambulance service furnished directly by a provider of services" },
  { code: "QP", description: "Documentation is on file showing that the laboratory test(s) was ordered individually or as a CPT-recognized panel" },
  { code: "QQ", description: "Ordering professional consulted a qualified clinical decision support mechanism for this service" },
  { code: "QR", description: "Item or service provided in a Medicare specified study" },
  { code: "QS", description: "Monitored anesthesia care service" },
  { code: "QT", description: "Recording and storage on tape by an analog tape recorder" },
  { code: "QW", description: "CLIA waived test" },
  { code: "QX", description: "CRNA service: with medical direction by a physician" },
  { code: "QY", description: "Medical direction of one certified registered nurse anesthetist (CRNA) by an anesthesiologist" },
  { code: "QZ", description: "CRNA service: without medical direction by a physician" },
  { code: "RA", description: "Replacement of a DME, orthotic or prosthetic item" },
  { code: "RB", description: "Replacement of a part of a DME, orthotic or prosthetic item furnished as part of a repair" },
  { code: "RC", description: "Right coronary artery" },
  { code: "RD", description: "Drug provided to beneficiary, but not administered incident-to" },
  { code: "RE", description: "Furnished in full compliance with FDA-mandated label/activation instructions" },
  { code: "RI", description: "Ramus intermedius coronary artery" },
  { code: "RR", description: "Rental" },
  { code: "RT", description: "Right side" },
  { code: "SA", description: "Nurse practitioner rendering service in collaboration with a physician" },
  { code: "SB", description: "Nurse midwife" },
  { code: "SC", description: "Medically necessary service or supply" },
  { code: "SD", description: "Services provided by registered nurse with specialized, highly technical home infusion training" },
  { code: "SE", description: "State and/or federally-funded programs/services" },
  { code: "SF", description: "Second opinion ordered by a professional review organization (PRO) per section 9401, P.L. 99-272" },
  { code: "SG", description: "Ambulatory surgical center (ASC) facility service" },
  { code: "SH", description: "Second concurrently administered infusion therapy" },
  { code: "SJ", description: "Third or more concurrently administered infusion therapy" },
  { code: "SK", description: "Member of high risk population" },
  { code: "SL", description: "State supplied vaccine" },
  { code: "SM", description: "Second surgical opinion" },
  { code: "SN", description: "Third surgical opinion" },
  { code: "SQ", description: "Item ordered by home health" },
  { code: "SS", description: "Home infusion services provided in the infusion suite of the IV therapy provider" },
  { code: "ST", description: "Related to trauma or injury" },
  { code: "SU", description: "Procedure performed in physician's office (to denote use of facility and equipment)" },
  { code: "SV", description: "Pharmaceuticals delivered to patient's home but not utilized" },
  { code: "SW", description: "Services provided by a certified diabetic educator" },
  { code: "SY", description: "Persons who are in close contact with member of high-risk population" },
  { code: "T1", description: "Left foot, second digit" },
  { code: "T2", description: "Left foot, third digit" },
  { code: "T3", description: "Left foot, fourth digit" },
  { code: "T4", description: "Left foot, fifth digit" },
  { code: "T5", description: "Right foot, great toe" },
  { code: "T6", description: "Right foot, second digit" },
  { code: "T7", description: "Right foot, third digit" },
  { code: "T8", description: "Right foot, fourth digit" },
  { code: "T9", description: "Right foot, fifth digit" },
  { code: "TA", description: "Left foot, great toe" },
  { code: "TC", description: "Technical component" },
  { code: "TD", description: "RN" },
  { code: "TE", description: "LPN/LVN" },
  { code: "TF", description: "Intermediate level of care" },
  { code: "TG", description: "Complex/high tech level of care" },
  { code: "TH", description: "Obstetrical treatment/services, prenatal or postpartum" },
  { code: "TJ", description: "Program group, child and/or adolescent" },
  { code: "TK", description: "Extra patient or passenger, non-ambulance" },
  { code: "TL", description: "Early intervention/individualized family service plan (IFSP)" },
  { code: "TM", description: "Individualized education program (IEP)" },
  { code: "TN", description: "Rural/outside providers' customary service area" },
  { code: "TP", description: "Medical transport, unloaded vehicle" },
  { code: "TQ", description: "Basic life support transport by a volunteer ambulance provider" },
  { code: "TR", description: "School-based individualized education program (IEP) services provided outside the public school district responsible for the student" },
  { code: "TS", description: "Follow-up service" },
  { code: "TT", description: "Individualized service provided to more than one patient in same setting" },
  { code: "TU", description: "Special payment rate, overtime" },
  { code: "TV", description: "Special payment rates, holidays/weekends" },
  { code: "TW", description: "Back-up equipment" },
  { code: "U1", description: "Medicaid level of care 1, as defined by each state" },
  { code: "U2", description: "Medicaid level of care 2, as defined by each state" },
  { code: "U3", description: "Medicaid level of care 3, as defined by each state" },
  { code: "U4", description: "Medicaid level of care 4, as defined by each state" },
  { code: "U5", description: "Medicaid level of care 5, as defined by each state" },
  { code: "U6", description: "Medicaid level of care 6, as defined by each state" },
  { code: "U7", description: "Medicaid level of care 7, as defined by each state" },
  { code: "U8", description: "Medicaid level of care 8, as defined by each state" },
  { code: "U9", description: "Medicaid level of care 9, as defined by each state" },
  { code: "UA", description: "Medicaid level of care 10, as defined by each state" },
  { code: "UB", description: "Medicaid level of care 11, as defined by each state" },
  { code: "UC", description: "Medicaid level of care 12, as defined by each state" },
  { code: "UD", description: "Medicaid level of care 13, as defined by each state" },
  { code: "UE", description: "Used durable medical equipment" },
  { code: "UF", description: "Services provided in the morning" },
  { code: "UG", description: "Services provided in the afternoon" },
  { code: "UH", description: "Services provided in the evening" },
  { code: "UJ", description: "Services provided at night" },
  { code: "UK", description: "Services provided on behalf of the client to someone other than the client" },
  { code: "UN", description: "Two patients served" },
  { code: "UP", description: "Three patients served" },
  { code: "UQ", description: "Four patients served" },
  { code: "UR", description: "Five patients served" },
  { code: "US", description: "Six or more patients served" },
  { code: "V5", description: "Vascular catheter" },
  { code: "V6", description: "Arteriovenous graft" },
  { code: "V7", description: "Arteriovenous fistula" },
  { code: "VM", description: "Medicare diabetes prevention program (MDPP) virtual make-up session" },
  { code: "VP", description: "Aphakic patient" },
  { code: "XE", description: "Separate encounter, a service that is distinct because it occurred during a separate encounter" },
  { code: "XP", description: "Separate practitioner, a service that is distinct because it was performed by a different practitioner" },
  { code: "XS", description: "Separate structure, a service that is distinct because it was performed on a separate organ/structure" },
  { code: "XU", description: "Unusual non-overlapping service, the use of a service that is distinct because it does not overlap usual components of the main service" },
];

const catalogByCode = HCPCS_MODIFIER_CATALOG.reduce<Record<string, string>>(
  (acc, item) => {
    acc[item.code.toUpperCase()] = item.description;
    return acc;
  },
  {}
);

const modifierCode = (value: unknown): string =>
  String(value ?? "")
    .trim()
    .toUpperCase();

const parseModifierItem = (item: unknown): HcpcsModifierOption | null => {
  if (typeof item === "string") {
    const text = item.trim();
    if (!text) return null;
    const split = text.split(/\s*[-–—:]\s*/);
    const code = modifierCode(split[0]);
    if (!code) return null;
    return {
      code,
      description: split.slice(1).join(" - ").trim() || catalogByCode[code] || "",
    };
  }
  if (!item || typeof item !== "object") return null;
  const record = item as Record<string, unknown>;
  const code = modifierCode(
    record.code ??
      record.Code ??
      record.modifier ??
      record.Modifier ??
      record.MODIFIER
  );
  if (!code) return null;
  const description = String(
    record.description ??
      record.Description ??
      record.label ??
      record.Label ??
      catalogByCode[code] ??
      ""
  ).trim();
  return { code, description };
};

export const extractCptModifiers = (
  metadata?: { CPT?: { MODIFIERS?: unknown } } | null
): HcpcsModifierOption[] => {
  const cpt = metadata?.CPT as Record<string, unknown> | undefined;
  const raw = cpt?.MODIFIERS ?? cpt?.modifiers ?? cpt?.Modifiers;
  let parsed: unknown = raw;
  if (typeof raw === "string") {
    const text = raw.trim();
    if (text.startsWith("[") || text.startsWith("{")) {
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = raw;
      }
    }
  }
  if (!Array.isArray(parsed)) return [];
  const seen: Record<string, true> = {};
  const out: HcpcsModifierOption[] = [];
  for (let i = 0; i < parsed.length; i += 1) {
    const item = parseModifierItem(parsed[i]);
    if (!item || seen[item.code]) continue;
    seen[item.code] = true;
    out.push(item);
  }
  return out;
};

const enrichModifier = (item: HcpcsModifierOption): HcpcsModifierOption => ({
  code: item.code,
  description: item.description || catalogByCode[item.code] || "",
});

const letterFirst = (left: HcpcsModifierOption, right: HcpcsModifierOption) => {
  const leftLetter = /^[A-Z]/i.test(left.code);
  const rightLetter = /^[A-Z]/i.test(right.code);
  if (leftLetter !== rightLetter) return leftLetter ? -1 : 1;
  return left.code.localeCompare(right.code, undefined, { numeric: true });
};

export const modifierOptionsForCode = (
  metadata?: { CPT?: { MODIFIERS?: unknown } } | null
): HcpcsModifierOption[] => {
  const fromMeta = extractCptModifiers(metadata).map(enrichModifier);
  if (fromMeta.length) return fromMeta;
  return HCPCS_MODIFIER_CATALOG.slice().sort(letterFirst);
};
